module.exports = __webpack_public_path__ + "static/img/Pagos.f75cd7ba.png";